export default __webpack_public_path__ + "static/uk-travel-045941b154c5a06464738ad916b35434.jpg";